import { IFormatter } from '../FormatterTypes';
import { TEDDisplayInt64 } from '../Displayers/TEDDisplayInt64';
import { TEDParseInt64 } from '../Parsers/TEDParseInt64';
import { TEDValidateNumber } from '../Validators/TEDValidateNumber';

class TEDFormatInt64 implements IFormatter {
  displayer = TEDDisplayInt64.getInstance();
  parser = TEDParseInt64.getInstance();
  validator = TEDValidateNumber.getInstance();
}

export { TEDFormatInt64 };
